import { validators } from '../components/common/Validation.js'

const SENDER_PAYS_MODES = ['paid', 'paid_balance']

export const DEFAULT_GTA_SGST = 2.5
export const DEFAULT_GTA_CGST = 2.5
export const DEFAULT_GTA_IGST = 5

export const senderPaysMode = (mode) =>
  SENDER_PAYS_MODES.includes(String(mode || '').trim().toLowerCase())

export const billingPartyGst = (mode, senderGst, receiverGst) =>
  senderPaysMode(mode) ? senderGst : receiverGst

export const gtaGstRates = (sameState, rcm = {}, { fallbackFivePercent = false } = {}) => {
  if (sameState) {
    const sgst = Number.parseFloat(rcm.sgst) || 0
    const cgst = Number.parseFloat(rcm.cgst) || 0
    if (fallbackFivePercent && sgst + cgst <= 0) {
      return { sgst: DEFAULT_GTA_SGST, cgst: DEFAULT_GTA_CGST, igst: 0 }
    }
    return { sgst, cgst, igst: 0 }
  }
  const igst = Number.parseFloat(rcm.igst) || 0
  if (fallbackFivePercent && igst <= 0) {
    return { sgst: 0, cgst: 0, igst: DEFAULT_GTA_IGST }
  }
  return { sgst: 0, cgst: 0, igst }
}

/**
 * Registered taxpayer for booking GST.
 * Empty, bad format, or verified invalid/inactive GSTIN → false.
 * Verification errors on a format-valid GSTIN are treated as registered
 * so a temporary API failure does not auto-add 5%.
 */
export const gstinIsRegistered = (gst, verificationOn, status) => {
  const value = String(gst || '').trim()
  if (!value) return false
  if (validators.gst(value)) return false
  if (!verificationOn) return true
  if (status?.lookup === 'done') {
    return Boolean(status.valid && status.active)
  }
  return true
}

/** Customer entered a GSTIN that is format-invalid or verified invalid/inactive. */
export const gstinIsInvalid = (gst, verificationOn, status) => {
  const value = String(gst || '').trim()
  if (!value) return false
  if (validators.gst(value)) return true
  if (!verificationOn) return false
  if (status?.lookup === 'done') {
    return !status.valid || !status.active
  }
  return false
}
